import React from "react";
import Banner from "./banners/Banner";
import { philbg } from "../assets";
import Schedule from "./banners/Schedule";

const Home = () => {
  return (
    <section
      id="home"
      className="w-full pb-10 pt-48 2xl:pt-44 xl:pt-28 lg:pt-20 flex border-b-[1px] border-b-black"
    >
      <div className="flex w-full h-auto">
        <div className="flex w-[45%] 2xl:w-[40%] xl:w-[30%] h-auto pl-16 2xl:pl-12 sm:pl-5">
          <Banner />
        </div>
        <div className="2xl:pt-32 md:pt-40 sm:pt-16 sm:w-[1000px]">
          <img src={philbg} alt="philbg" />
        </div>
      </div>

      <div
        className="top-[650px] 2xl:top-[550px] xl:top-[500px] lg:top-[330px] md:top-[300px] sm:top-[300px] right-[600px] 2xl:right-[450px] xl:right-[350px] lg:right-[550px] md:right-[300px] sm:right-0 absolute z-20"
        sizes="(max-width:768) 100vw, (max-width: 1200px) 50vw, 50vw"
      >
        <Schedule />
      </div>
    </section>
  );
};

export default Home;
